//TODO: DELETE ME
export default [
  4,
  5,
  6,
  7,
  8
];



// WEBPACK FOOTER //
// ./shared/common/staticData/hoursPerDayList.js